import styles from "./styles.module.scss";
import FPI from "../../assets/images/FPI.png";

export const SupportPage = () => {
  return (
    <div className={styles.supportpage}>
      <h2 className={styles.title}>
        Проект реализуетя при поддержке Фонда содействия инновациям и
        федерального проекта «Отечественные решения»
      </h2>
      <div className={styles.photoholder}>
        <img src={FPI} alt="fpi" className={styles.photo} />
      </div>
    </div>
  );
};
